import { Controller } from "@hotwired/stimulus";

class CustomerLoveController extends Controller {
  static targets = ["itemsContainer", "viewMoreButton", "gradientOverlay"];

  showMore() {
    // Remove the max-height classes from container to reveal all content
    if (this.hasItemsContainerTarget) {
      this.itemsContainerTarget.classList.remove("max-h-[4200px]", "md:max-h-[2100px]", "lg:max-h-[1400px]");
    }

    // Hide the gradient overlay
    if (this.hasGradientOverlayTarget) {
      this.gradientOverlayTarget.classList.add("hidden");
    }

    // Hide the view more button
    if (this.hasViewMoreButtonTarget) {
      this.viewMoreButtonTarget.classList.add("hidden");
    }
  }
}

export default CustomerLoveController;